import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Changelog' })((theme) => ({
    container: {
        maxWidth: 1065,
        margin: '40px auto 96px auto',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            margin: '16px auto 96px auto'
        }
    },
    title: {
        marginBottom: 80,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginBottom: 40
        }
    },
    cards: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: 20,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gridTemplateColumns: '1fr'
        }
    }
}));
